<div class="wrapper">
  <app-navbar></app-navbar>
  <div class="d-flex">
    <app-sidebar class="sidebar"></app-sidebar>
    <div class="flex-grow-1">
      <div class="row">
        <div class="col-12">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>